import TtamProductDetailsSource from './products-from/index.vue';
import TtamProductDetailsDesc from './description/index.vue';
import TtamProductDetailsProductSet from './products-set/index.vue';
import TtamProductDetailsSpecificType from './products-specific-type/index.vue';
import TtamProductDetailsProductsList from './products-list/list.vue';
import TtamProductDetailsProductsListActions from './products-list-actions/index.vue';

import * as hooks from './hooks';
export default {
  TtamProductDetailsSource,
  TtamProductDetailsDesc,
  TtamProductDetailsSpecificType,
  TtamProductDetailsProductSet,
  TtamProductDetailsProductsList,
  TtamProductDetailsProductsListActions,
  ...hooks,
};
